let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g5iwt")).then(() => parcelRequire('5ldJN'));